<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<div class="mb-3">
					<label class="form-label" for="filters.name">Nazwa (zawiera)</label>
					<input
						type="text"
						class="form-control"
						id="filters.name"
						name="filters.name"
						[(ngModel)]="filters.name"
					/>
				</div>
				<div class="mb-3">
					<label class="form-label">Wyjazd z pierwszego przystanku</label>
					<div class="row g-2">
						<div class="col-md">
							<input
								type="date"
								class="form-control"
								name="filters.departureFromFirstStop_from"
								[(ngModel)]="filters.departureFromFirstStop_from"
								id="departureFromFirstStop_from"
							/>
						</div>
						<div class="col-md">
							<input
								type="date"
								class="form-control"
								name="filters.departureFromFirstStop_to"
								[(ngModel)]="filters.departureFromFirstStop_to"
							/>
						</div>
					</div>
				</div>
				<div class="mb-3">
					<label class="form-label">Data zakwaterowania</label>
					<div class="row g-2">
						<div class="col-md">
							<input
								type="date"
								class="form-control"
								name="filters.arrivalAtDestination_from"
								[(ngModel)]="filters.arrivalAtDestination_from"
								id="arrivalAtDestination_from"
							/>
						</div>
						<div class="col-md">
							<input
								type="date"
								class="form-control"
								name="filters.arrivalAtDestination_to"
								[(ngModel)]="filters.arrivalAtDestination_to"
							/>
						</div>
					</div>
				</div>
				<div class="mb-3">
					<label class="form-label">Zakończenie sprzedaży</label>
					<div class="row g-2">
						<div class="col-md">
							<input
								type="date"
								class="form-control"
								name="filters.saleClosingDate_from"
								[(ngModel)]="filters.saleClosingDate_from"
								id="saleClosingDate_from"
							/>
						</div>
						<div class="col-md">
							<input
								type="date"
								class="form-control"
								name="filters.saleClosingDate_to"
								[(ngModel)]="filters.saleClosingDate_to"
							/>
						</div>
					</div>
				</div>
				<div class="mb-3">
					<label class="form-label">Data do potwierdzenia</label>
					<div class="row g-2">
						<div class="col-md">
							<input
								type="date"
								class="form-control"
								name="filters.confirmDeadline_from"
								[(ngModel)]="filters.confirmDeadline_from"
								id="confirmDeadline_from"
							/>
						</div>
						<div class="col-md">
							<input
								type="date"
								class="form-control"
								name="filters.confirmDeadline_to"
								[(ngModel)]="filters.confirmDeadline_to"
							/>
						</div>
					</div>
				</div>
				<div class="mb-3">
					<label class="form-label" for="filters.name">Status</label>
					<ng-select
						id="statuses"
						name="statuses"
						[(ngModel)]="filters.status"
						[multiple]="true"
						[closeOnSelect]="false"
					>
						<ng-option *ngFor="let item of statuses" [value]="item.id">{{ item.name }}</ng-option>
					</ng-select>
				</div>
				<div class="mb-3">
					<label class="form-label">Opiekun</label>
					<ng-select
						id="owner"
						name="owner"
						[(ngModel)]="filters.owner"
						[items]="users"
						bindLabel="name"
						bindValue="id"
						placeholder="Opiekun"
					></ng-select>
				</div>
				<div class="mb-3">
					<label class="form-label" for="filters.name">Rodzaj transportu</label>
					<ng-select
						id="kinds"
						name="kinds"
						[(ngModel)]="filters.kind"
						[multiple]="true"
						[closeOnSelect]="false"
					>
						<ng-option *ngFor="let item of kinds" [value]="item.id">{{ item.name }}</ng-option>
					</ng-select>
				</div>
			</div>

			<div class="modal-footer">
				<div class="row row-full">
					<div class="col-sm-4">
						<button type="button" class="btn btn-secondary" (click)="filtersClear()">Wyczyść filtry</button>
					</div>
					<div class="col-sm-8 text-end">
						<button type="button" class="btn btn-primary me-2" (click)="filtersSave()">Pokaż</button>
						<button
							type="button"
							class="btn btn-secondary"
							(click)="filtersClose()"
							data-bs-dismiss="modal"
						>
							Anuluj
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
